import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['main', 'areaOfInterventionSelect'];
  static values = { skilledInterventionUrl: String };

  connect() {
    document.addEventListener('fieldAdded', this.addListeners);
    this.addListeners();
  }

  addListeners = () => {
    const skilledContainer = this.mainTarget.querySelectorAll('.skilled-intervention');
    const skilledInterventionUrl = this.skilledInterventionUrlValue;

    skilledContainer.forEach((sc) => {
      const autocompleteSkilled = sc.querySelector('awc-autocomplete');

      autocompleteSkilled.setAttribute(
        'src',
        `${skilledInterventionUrl}&major_focus_area_tag_id=${this.areaOfInterventionSelectTarget.value}`
      );
    });
  };

  updateAreaOfIntervention(event) {
    const areaOfInterventionId = event.target.value;
    const skilledContainer = this.mainTarget.querySelectorAll('.skilled-intervention');
    const skilledInterventionUrl = this.skilledInterventionUrlValue;

    skilledContainer.forEach((sc) => {
      const autocompleteSkilled = sc.querySelector('awc-autocomplete');
      const input = autocompleteSkilled.querySelector('.awc-autocomplete-input');

      autocompleteSkilled.setAttribute(
        'src',
        `${skilledInterventionUrl}&major_focus_area_tag_id=${areaOfInterventionId}`
      );

      input.addEventListener('focus', () => {
        this.clearOptions('', autocompleteSkilled);
      });
    });
  }

  async clearOptions(options, autocomplete) {
    autocomplete.optionsContainer.innerHTML = options;
    autocomplete.reset();
    autocomplete.clear();
    autocomplete.combobox.stop();
    autocomplete.combobox.start();
    autocomplete.combobox.initializeOptions();
    autocomplete.selectVariant.start();
    autocomplete.searchVariant.search('');
    await autocomplete.reposition();
  }
}
